/**
 * 판정 기록 목록 organism — styled.
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RowLink = styled.a`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 10px;
  text-decoration: none;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
  &:hover {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  }
`;

/** 모든 칸은 1줄(nowrap) — 행 높이를 한 줄로 고정한다. */
export const Cell = styled.div`
  font-size: 13px;
  flex-shrink: 0;
  white-space: nowrap;
`;

/** 약품명 — 가변폭·1줄 말줄임(단일 255자 이름도 행 높이 1줄 유지, AC L1264). */
export const NameCell = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const SubText = styled.span`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const StateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  font-size: 14px;
`;

export const HintText = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;
